module.exports = __webpack_public_path__ + "img/workshops_2.3.0e9cd79b.jpeg";